import EducationPhilosophySection from './EducationPhilosophySection.component';

export default EducationPhilosophySection;